import { svg } from "lit";
const icon = svg `<path d="M5.50006 15.5H7.78854V10.5481H12.2116V15.5H14.5001V8.25003L10.0001 4.85901L5.50006 8.25003V15.5ZM4.41675 16.5833V7.70838L10.0001 3.50488L15.5834 7.70838V16.5833H11.1283V11.6314H8.87185V16.5833H4.41675Z" fill="currentColor"/>`;
export default icon;
